import React from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Persistent non-dismissible disclaimer footer bar shown on signal-generating screens.
 * Renders a slim 32px bar above navigation on routes that produce trading signals or leads.
 */
const DISCLAIMER_ROUTES = [
  '/trading/banker/leads',
  '/trading/signals',
  '/trading/strategies',
  '/trading/expert',
  '/trading/banker/chat',
];

const DisclaimerFooter: React.FC = () => {
  const { pathname } = useLocation();

  const shouldShow =
    DISCLAIMER_ROUTES.some((route) => pathname === route || pathname.startsWith(route + '/')) ||
    pathname.includes('/signals') ||
    pathname.startsWith('/branch/meeting');

  if (!shouldShow) return null;

  return (
    <div
      className="w-full bg-slate-800 border-t border-slate-700 flex items-center justify-center px-4 shrink-0"
      style={{ height: '32px', minHeight: '32px' }}
      data-testid="disclaimer-footer"
    >
      <p className="text-xs text-slate-400 text-center leading-tight">
        <span className="mr-1">ⓘ</span>
        For informational purposes only. Not financial advice.{' '}
        my investments is not a licensed FSP. Trade at your own risk.
      </p>
    </div>
  );
};

export default DisclaimerFooter;
